import api from '@pray/shared/utils/api';

import type { GetReportResponse } from './data/response';

type GetReportProps = {
  artistId: string;
  reportId: string;
};

export async function getReport({ artistId, reportId }: GetReportProps): Promise<GetReportResponse> {
  if (!artistId) throw new Error('Artist ID is required');
  if (!reportId) throw new Error('Report ID is required');

  const url = `/web/studio/artists/${artistId}/reports/${reportId}`;

  const response = await api.executeGetRequest<GetReportResponse>(url);
  return response.data;
}
